const successCode = [200, 201, 202, 203, 204, 205, 207, 208, 226];
import store from '@/store';

export const autoLogOutTimeSet = (status) => {
  const token = localStorage.getItem('tsm-user-token');
  const trasnporterToken = localStorage.getItem('tsm-transporter-token');
  if (successCode.includes(status) && ((token && token !== 'undefined') || (trasnporterToken && trasnporterToken !== 'undefined'))) {
    const autoLogoutTime = store.getters['app/autoLogoutTime'] || 30;
    const currentTime = new Date().getTime() + (autoLogoutTime * 60 * 1000);
    localStorage.setItem('et-na', currentTime);
  }
};
export const autoLogout = (store) => {
  const elapsedTime = localStorage.getItem('et-na');
  if ((elapsedTime && elapsedTime !== 'undefined')) {
      setInterval(() => {
      const updatedElapsedTime = localStorage.getItem('et-na');
      const currentTime = new Date().getTime();
      const token = localStorage.getItem('tsm-user-token');
      const trasnporterToken = localStorage.getItem('tsm-transporter-token');
      if ((currentTime > updatedElapsedTime) && ((token && token !== 'undefined') || (trasnporterToken && trasnporterToken !== 'undefined'))) {
         store.dispatch('app/logout', { data: { message: 'Your session has been timed out, please login again.....' } });
      }
    }, 5000);
  }
};
